import {
  LIST_QUIZZ,
  LIST_QUIZZ_SUCCESS,
  LIST_QUIZZ_CLEAN,
  LIST_QUIZZ_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  quizz: [],
}

const QuizzList = (state = initialState, action) => {
  switch (action.type) {
    case LIST_QUIZZ:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_QUIZZ_SUCCESS:
      state = {
        ...state,
        quizz: action.payload.quizz,
        loading: false,
        done: true,
      }
      break
    case LIST_QUIZZ_CLEAN:
      state = initialState
      break
    case LIST_QUIZZ_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default QuizzList
